import * as React from 'react';
import { EditState, EditProps, BaseRouteProps } from '../../interfaces';
import { Tenant } from '../../models';
import { TenantDataService } from '../../services';
import { NavLink } from 'react-router-dom';
import { TenantForm } from './TenantForm';
import { LoadingIndicator, PVAPage } from '../../components';

interface TenantEditState extends EditState<Tenant> {
    loading: boolean;
}

export class TenantEdit extends React.Component<BaseRouteProps<EditProps>, TenantEditState> {
    private tenantDataService = new TenantDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<EditProps>) {
        super(props);

        this.state = {
            originalEntity: undefined,
            loading: false
        };

        this.save = this.save.bind(this);
    }

    public componentDidMount() {
        const id = this.props.match.params.id;

        if (id) {
            this.tenantDataService.get(id).then((tenant: Tenant) => {
                this.setState({ originalEntity: tenant });
            });
        }
    }

    private midranges() {

        this.setState(
            {
                loading: true
            }, 
            () => {
                this.tenantDataService.calculateMidRanges().then(
                    () => {
                        this.props.notificationService.addInfo('Finished');
                        this.setState({
                            loading: false
                        });
                    },
                    (err: any) => {
                        this.props.notificationService.addError(err);
                        console.error(err);
                        this.setState({
                            loading: false
                        });
                    }
                );
            });
    }

    public render() {
        if ((this.props.match.params.id && !this.state.originalEntity) || this.state.loading) {
            return <LoadingIndicator />;
        }

        return (
            <PVAPage>
                <PVAPage.Header>
                    <PVAPage.Header.Title>
                        <NavLink to={`/tenant`}>
                            <span className="glyphicon glyphicon-triangle-left" />
                        </NavLink>
                        &nbsp;
                        Edit Tenant
                    </PVAPage.Header.Title>
                </PVAPage.Header>

                <PVAPage.Body>
                    <TenantForm defaultValues={this.state.originalEntity} submit={this.save} />

                    <hr />

                    <button className="btn btn-success" onClick={(e) => this.midranges()}><span className="glyphicon glyphicon-asterisk" /> Calculate Mid Ranges</button>

                </PVAPage.Body>

                <PVAPage.Footer />
            </PVAPage>);
    }

    private save(values: any) {
        this.tenantDataService.update(values).then((success) => {
            this.props.history.push('/tenant');
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/tenant/TenantEdit.tsx